{
  "title": "Scheduled Reports",
  "subtitle": "Configure automated email reports for your FBO",

  "status": {
    "notConfigured": "Not Configured",
    "disabled": "Disabled",
    "enabled": "Enabled"
  },

  "lastRun": {
    "never": "Never",
    "justNow": "Just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} hr ago"
  },

  "occupancy": {
    "title": "Nightly Occupancy Report",
    "subtitle": "Daily aircraft snapshot",
    "description": "Automatically emails a snapshot of all aircraft in hangars and ramps at a scheduled time each night."
  },

  "labels": {
    "locations": "Locations",
    "hangars": "hangars",
    "ramps": "ramps",
    "selected": "selected",
    "snapshotTime": "Report Time",
    "recipients": "Recipients",
    "emailsConfigured": "email(s) configured",
    "lastRun": "Last Run",
    "nextRun": "Next Run",
    "error": "Error:"
  },

  "buttons": {
    "configure": "Configure",
    "setUp": "Set Up Report",
    "disable": "Disable"
  },

  "disableDialog": {
    "title": "Disable Report",
    "message": "Are you sure you want to disable this scheduled report? You can re-enable it later.",
    "confirm": "Disable Report"
  },

  "configDialog": {
    "titleNew": "Set Up Occupancy Report",
    "titleEdit": "Configure Occupancy Report",
    "testEmailSent": "Test email sent! Check your inbox.",

    "fields": {
      "enableReport": "Enable scheduled report",
      "hangars": "Hangars",
      "selectHangars": "Select hangars...",
      "hangarsHelp": "Select hangars to include in the report",
      "ramps": "Ramps",
      "selectRamps": "Select ramps...",
      "rampsHelp": "Select ramps to include in the report",
      "noRampsAvailable": "No ramps available",
      "snapshotTime": "Report Time",
      "snapshotTimeHelp": "When to capture and send the report",
      "recipients": "Email Recipients",
      "recipientsHelp": "Comma-separated list of email addresses to receive the report",
      "fileFormat": "Attachment Format",
      "fileFormatHelp": "CSV opens directly in Excel. TSV uses tab-separated values.",
      "timezone": "Timezone"
    },

    "buttons": {
      "sendTest": "Send Test Email"
    },

    "errors": {
      "noLocationsSelected": "Please select at least one hangar or ramp",
      "noRecipients": "Please enter at least one email address",
      "invalidEmails": "Invalid email address(es): {{emails}}",
      "noSnapshotTime": "Please set a report time",
      "saveFailed": "Failed to save report configuration. Please try again.",
      "testFailed": "Failed to send test email. Please try again."
    }
  }
}
